import { Checkbox, FormControlLabel, Grid, TableRow, Tooltip } from '@mui/material';
import DataTableBodyCell from './DataTableBodyCell';
import { useNavigate } from 'react-router-dom';
import { IconButton, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import MDButton from 'components/MDButton';
import { useState } from 'react';
import MDInput from 'components/MDInput';
import { addResources } from 'services/players';

function DataTableBodyRow({
  row,
  noEndBorder,
  object,
  noActions,
  openDelete,
  handleCloseDelete,
  handleDelete,
  rowsLength,
  showAdd,
  view,
  filters,
  setFilters
}) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gems, setGems] = useState('');
  const [coins, setCoins] = useState('');
  const [grantVip, setGrantVip] = useState(false);
  function handleModal() {
    if (isModalOpen) {
      setGems('');
      setCoins('');
      setGrantVip(false);
    }
    setIsModalOpen(!isModalOpen);
  }
  const handleAdd = async (id) => {
    try {
      const res = await addResources(id, gems, coins, grantVip);
      handleModal();
      if (res.status === 200 || res.status === 201) {
        alert('Successfully updated player resources!');
        setFilters({
          ...filters,
          refresh: filters?.refresh ? !filters.refresh : true
        });
      } else {
        alert('Something went wrong!');
      }
    } catch (error) {
      alert(error?.response?.data?.message || error?.message || 'Something went wrong!');
    }
  };

  return (
    <TableRow {...row.getRowProps()}>
      {row.cells.map((cell, index) => (
        <DataTableBodyCell
          key={`player-data-${index}`}
          noBorder={noEndBorder && rowsLength - 1 === index}
          align={cell.column.align ? cell.column.align : 'left'}
          {...cell.getCellProps()}
          expanded={row.isExpanded}
        >
          {cell.render('Cell')}
        </DataTableBodyCell>
      ))}
      {showAdd && view && (
        <DataTableBodyCell noBorder={noEndBorder} width='0.5rem' align='left'>
          <Tooltip title='Add resources'>
            <IconButton color='info' onClick={() => handleModal()}>
              <Icon>add</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title='View'>
            <IconButton color='info' onClick={() => navigate(`show/${row?.original?.id}`, { replace: false })}>
              <Icon>visibility</Icon>
            </IconButton>
          </Tooltip>
        </DataTableBodyCell>
      )}
      {!noActions && (
        <DataTableBodyCell
          // noBorder={noEndBorder && rowsLength - 1 === index}
          width='0.5rem'
          align='left'
        >
          <Tooltip title='View'>
            <IconButton color='info' onClick={() => navigate(`show/${row?.original?.id}`, { replace: false })}>
              <Icon>visibility</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title='Edit'>
            <IconButton color='info' onClick={() => navigate(`edit/${row?.original?.id}`, { replace: false })}>
              <Icon>edit</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title='Delete'>
            <IconButton
              color='error'
              onClick={() => handleDelete(row?.original?.id)}
              // onClick={handleOpenDelete}
            >
              <Icon>delete</Icon>
            </IconButton>
          </Tooltip>
          <Dialog
            open={openDelete}
            onClose={handleCloseDelete}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>{`Delete ${object}`}</DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                Are you sure you want to delete this {object}?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton variant='text' onClick={handleCloseDelete}>
                No
              </MDButton>
              <MDButton variant='text' color='error' onClick={() => handleDelete(row?.original?.id)}>
                yes
              </MDButton>
            </DialogActions>
          </Dialog>
        </DataTableBodyCell>
      )}
      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={handleModal}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            // style={{ color: 'black' }}
            id='alert-dialog-title'
          >{`Add more resource to ${row?.values?.nickname}`}</DialogTitle>
          <DialogContent>
            <Grid container gap={5} pt={1}>
              <MDInput type='number' onChange={(e) => setGems(e.target.value)} value={gems} label='Gems'></MDInput>
              <MDInput type='number' onChange={(e) => setCoins(e.target.value)} value={coins} label='Coins'></MDInput>
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox checked={grantVip} onChange={(e) => setGrantVip(e.target.checked)} />}
                  label={`Grant VIP status (current: ${row?.original?.vip > 0 ? 'Yes' : 'No'})`}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            {/* <MDButton
                    variant='text'
                    color='error'
                    onClick={() => {
                      handleModal();
                    }}
                  >
                    Не
                  </MDButton> */}
            <MDButton variant='text' onClick={() => handleAdd(row?.original?.id)}>
              Add
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
    </TableRow>
  );
}

export default DataTableBodyRow;
